import { Box, Checkbox } from "@mui/material";
import { DropdownFilter, Input, SectionDivider } from "../..";
import { useStyles } from "./style";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const Billing = () => {
  const { t } = useTranslation();

  const classes = useStyles();
  const [selectedLevel, setSelectedLevel] = useState<string>("Basic");
  const [selectedStatus, setSelectedStatus] = useState<string>("New");
  const levelsOptions = ["Basic", "Standard", "Premium"];
  const statusOptions = ["New", "Paused", "Canceled", "Expired", "Trial"];
  return (
    <Box className={classes.container}>
      <Input label={t("accountDetails.accountName")} required />

      <SectionDivider label={t("accountDetails.address")} />

      <Box className={classes.rowWrapper}>
        <Box sx={{ width: "20%" }}>
          <Input label={t("accountDetails.num")} />
        </Box>
        <Box sx={{ width: "80%" }}>
          <Input label={t("accountDetails.street")} />
        </Box>
      </Box>

      <Box className={classes.rowWrapper}>
        <Input label={t("accountDetails.city")} />
        <Input label={t("accountDetails.zip")} />
      </Box>

      <Input label={t("accountDetails.phone")} required />

      <Box className={classes.checkBoxAndSectionWrapper}>
        <Checkbox
          sx={{
            color: "#CCCCCC",
            padding: "4px",
          }}
        />
        <SectionDivider label={t("accountDetails.billingAddress")} />
      </Box>

      <SectionDivider label={t("accountDetails.subscription")} />

      <Box className={classes.rowWrapper}>
        <DropdownFilter
          label={t("accountDetails.level")}
          options={levelsOptions}
          selected={selectedLevel}
          onSelect={(level) => setSelectedLevel(level)}
        />
        <DropdownFilter
          label={t("accountDetails.status")}
          options={statusOptions}
          selected={selectedStatus}
          onSelect={(status) => setSelectedStatus(status)}
        />
      </Box>

      <Box className={classes.rowWrapper}>
        <Box className={classes.label}>{t("accountDetails.created")}</Box>
        <Box className={classes.value}>10-15-24</Box>
      </Box>

      <Box className={classes.rowWrapper}>
        <Box className={classes.label}>{t("accountDetails.updated")}</Box>
        <Box className={classes.value}>10-15-24</Box>
      </Box>
    </Box>
  );
};
